module.exports = __webpack_public_path__ + "img/askg.64e67a97.svg";